





















import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class CriminalRecord extends GlobalMixins {
	criminalRecord: 'yes' | 'no' | false = false

	@Watch('criminalRecord')
	onCriminalRecordChange(): void {
		if (this.criminalRecord) {
			this.$store.dispatch('setCriminalRecord', this.criminalRecord)

			if (this.criminalRecord === 'yes') {
				this.$router.push({ name: this.language === Languages.NL ? 'select-crime' : 'select-crime-'+this.language })
			} else {
				this.$router.push({ name: this.language === Languages.NL ? 'results' : 'results-'+this.language })
			}
		}
	}

	mounted() {
		bus.$emit('setNextButton', false)
	}
}
